import { ThisReceiver } from '@angular/compiler';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { currentUser, User } from 'src/app/core/mad-auth/mad-auth.store';
import { AppState } from 'src/app/core/reducers';
import { selectValuationProcessLoadingState, selectValuationProcessValuation, ValuationProcessTargetPropertyModel, ValuationProcessValuationModel } from 'src/app/core/valuation-process';
import { FullComparablesRequested } from 'src/app/core/valuation-process/_actions';
import { AddedComparablesRequested } from 'src/app/core/valuation-process/_actions/valuation-comparable.actions';
import { ApartmentModalComponent } from '../../../comparable/apartments/modal/apartment-modal.component';
import { HouseModalComponent } from '../../../comparable/house/modal/house-modal.component';
import { LandModalComponent } from '../../../comparable/lands/modal/land-modal.component';
import { OfficeModalComponent } from '../../../comparable/offices/modal/office-modal.component';
import { ParkingModalComponent } from '../../../comparable/parkings/modal/parking-modal.component';
import { RetailBuildingModalComponent } from '../../../comparable/retail-building/modal/retail-building-modal.component';
import { RetailsModalComponent } from '../../../comparable/retails/modal/retails-modal.component';
import { WarehouseModalComponent } from '../../../comparable/warehouse/modal/warehouse-modal.component';

@Component({
  selector: 'kt-comparables-tab-v2',
  templateUrl: './comparables-tab-v2.component.html',
  styleUrls: ['./comparables-tab-v2.component.scss']
})
export class ComparablesTabV2Component implements OnInit {

  @Input() targetProperty: ValuationProcessTargetPropertyModel; 
  @Input() valuation: ValuationProcessValuationModel
  loading$ = this.store$.select(selectValuationProcessLoadingState)
  valuation$ = this.store$.select(selectValuationProcessValuation)

  currentUser: User;

  constructor(
    private store$: Store<AppState>,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.store$.pipe(take(1), select(currentUser)).subscribe(user => this.currentUser = user);
  }

  addComparable() {
    let dialogRef = null;
    switch (this.targetProperty.generalInfo.propertySubType) {
      case 'Apartment': {
        dialogRef = this.dialog.open(ApartmentModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
      case 'House': {
        dialogRef = this.dialog.open(HouseModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
      case 'Office': {
        dialogRef = this.dialog.open(OfficeModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
      case 'Retail Shop': {
        dialogRef = this.dialog.open(RetailsModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
      case 'Retail Building': {
        dialogRef = this.dialog.open(RetailBuildingModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
      case 'Parking': {
        dialogRef = this.dialog.open(ParkingModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
      case 'Warehouse': {
        dialogRef = this.dialog.open(WarehouseModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
      case 'Land': {
        dialogRef = this.dialog.open(LandModalComponent, {
          width: '80vw',
          data: {
            valuationId: this.valuation.valuationId
          }
        })
        break;
      }
    }

    if (dialogRef != null) {
      dialogRef.afterClosed().subscribe(res => {
        if (!res) {
          return;
        }
        this.store$.dispatch(new AddedComparablesRequested({refNum: res.ref_num}))
      })
    }
  }

}
